import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';
export function OpeningHook() {
  const {
    language
  } = useLanguage();
  const t = translations[language].openingHook;
  return <section className="py-12 md:py-20 px-4 bg-gradient-to-b from-black to-teal-950" data-id="element-137">
      <div className="max-w-4xl mx-auto text-center" data-id="element-138">
        <p className="text-xl md:text-3xl leading-relaxed text-teal-100" data-id="element-139">
          {t.text} <span className="text-red-400" data-id="element-140">{t.reacting}</span> {t.and}{' '}
          <span className="text-yellow-400" data-id="element-141">{t.controller}</span>.
        </p>
        <p className="text-2xl md:text-4xl font-bold mt-6 md:mt-8 text-yellow-400" data-id="element-142">
          {t.question}
        </p>
      </div>
    </section>;
}